// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723605081046/Frame%201000008957.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723606077698/%E8%BD%A6%E5%85%85.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724644501111/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724644501932/b1.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725153964645/euPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725153964826/euH3.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725160504233/ukH3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725160504233/ukH3.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
    nl: imgAll1.EU,
};
export default imgLocale1;
